import { memo, SyntheticEvent, useCallback } from "react"

import { stripDataAttributesFromProps } from "@izettle/react"

import { OutsideClickHandler } from "../../../outside-click-handler"
import { useDropdown } from "../../hooks"
import { Handler } from "../handler"
import { Modal } from "../modal"

import { Container, FullContainer, List } from "./components"

export const DropdownComponent = memo(() => {
  const { children, className, dropdownProps, isMobileView, isOpen, close } =
    useDropdown()
  const attributes = stripDataAttributesFromProps(dropdownProps)

  const onContainerClick = useCallback((event: SyntheticEvent) => {
    // To prevent outside click handler from being executed
    event.nativeEvent.stopImmediatePropagation()
  }, [])

  if (isMobileView) {
    return (
      <FullContainer {...attributes} className={className}>
        <Handler />
        <Modal />
      </FullContainer>
    )
  }

  return (
    <OutsideClickHandler onOutsideClick={close}>
      {({ ref }) => (
        <Container
          {...attributes}
          className={className}
          ref={ref}
          onClick={onContainerClick}
        >
          <Handler />

          {isOpen && <List>{children}</List>}
        </Container>
      )}
    </OutsideClickHandler>
  )
})
